import axios from 'axios'
import Vue from 'vue'

// 创建 axios 实例
const service = axios.create({
  baseURL: 'https://mmxdgame.com', // api 的 base_url
  timeout: 5000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如显示 loading
    Vue.prototype.$loading.show()
    
    // 设置请求头，例如添加 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    return config
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error) // for debug
    Vue.prototype.$loading.hide()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 响应成功后做些什么
    // 隐藏 loading
    Vue.prototype.$loading.hide()
    
    // 根据业务需求处理响应数据
    const res = response.data
    
    // 这里假设业务状态码为 200 表示成功
    if (res.code !== 200) {
      // 提示错误信息
      Vue.prototype.$message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 例如：401 表示未登录，跳转到登录页
      if (res.code === 401) {
        Vue.prototype.$router.push('/login')
      }
      
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // 处理响应错误
    console.error('响应错误:', error) // for debug
    Vue.prototype.$loading.hide()
    
    // 统一错误提示
    Vue.prototype.$message({
      message: error.message || '网络错误，请稍后重试',
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service  